export { default as ModalFS } from './ModalFullScreen';
